module.exports = __webpack_public_path__ + "media/styles/images/png/pencil-gray-on-white-ee7cb5aa3909080430b45527e55cbe92.png";